/**
 * @author jakubbujakowski
 * @since 2021-1-29
 */

import React from "react";
import { useHistory } from "react-router";

import { showToast } from "@containers/Toastify";

interface Props {
  children?: React.ReactNode;
  originRoute: string;
  invalidSessionTokenErrorText: string;
  accessToken: string | null;
  isTokenInvalid: boolean;
  isLocalStorageChecked: boolean;
  onInvalidAccessToken: () => { type: string };
}

export const TokenGuard = (props: Props): React.ReactElement => {
  const history = useHistory();

  React.useEffect(() => {
    if (
      props.isLocalStorageChecked &&
      (props.isTokenInvalid || !props.accessToken)
    ) {
      history.push(props.originRoute);
      props.onInvalidAccessToken();
      showToast(props.invalidSessionTokenErrorText, {
        type: "error",
      });
    }
  }, [props.isLocalStorageChecked, props.isTokenInvalid, props.accessToken]);

  return <React.Fragment>{props.children}</React.Fragment>;
};
